/**
 * Reads common session identifying information from browser storage
 * to be appended to log entries based on the configured commonInfoKeys.
 */
export function readCommonInfo(keys?: string[]): Record<string, unknown> {
  const result: Record<string, unknown> = {}
  
  if (!keys || keys.length === 0 || typeof window === 'undefined') {
    return result
  }

  let userInfo: Record<string, unknown> = {}
  try {
    const raw = window.sessionStorage.getItem('userInfo') || window.localStorage.getItem('userInfo')
    if (raw) {
      userInfo = JSON.parse(raw)
    }
  } catch {
    // ignore parse errors
  }

  const sessionId = window.sessionStorage.getItem('sessionId')
  const correlationId = window.sessionStorage.getItem('correlationId')

  // Construct a merged context object
  const context: Record<string, unknown> = {
    ...userInfo,
    sessionId: sessionId || undefined,
    correlationId: correlationId || undefined,
  }

  for (const key of keys) {
    if (context[key] !== undefined && context[key] !== null) {
      result[key] = context[key]
    }
  }

  return result
}
